import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, Table, CardBody, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
import * as moment from 'moment';
import { TOKEN } from '../../_helpers/token';

import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'


export class PromoCodeOnwers extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                key: "phone",
                TrOnlyClassName: 'tsc',
                text: "Phone Numnber",
                className: "tsc",
                align: "left"
            },
            {
                key: "promoCode",
                TrOnlyClassName: 'tsc',
                text: "PromoCode",
                className: "tsc",
                align: "left"
            },
            {
                key: "t_amount",
                TrOnlyClassName: 'tsc',
                text: "Referral Income Balance",
                className: "tsc",
                align: "left"
            },
            {
                key: "t_customers",
                TrOnlyClassName: 'tsc',
                text: "Customer Counts",
                className: "tsc",
                align: "left"
            }
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [100, 200, 500],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 100,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No data was found",
                filter: "Enter date (YYYY-MM-DD)",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                print: false,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };

    }
    componentDidMount() {
        this.getData()
    }

    formatCurrency = amount => {
        return new Intl.NumberFormat(this.state.locale, {
            style: 'currency',
            currency: "ABS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount).replaceAll('ABS', '');
    };



    onSubmitProfifile(record) {
        // alert(this.state.phone_number.replaceAll("+", ""))
        let formData = {
            "msisdn": record.phone
        }
        // alert()
        console.log("DATA", JSON.stringify(formData))
        this.setState({ isLoading: true });
        axios.get(baseURL + 'customersone/' + record.phone, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            // console.log("bayo", response.data)
            if (response.data.status) {
                this.setState({
                    statusMessage: "Success! Redirecting....",
                    isShowError: true, isLoading: false, showError: false,
                });
                window.location.href = "userdetail"
                localStorage.setItem('phone', record.phone)
                localStorage.setItem('phone_id', response.data.data[0].id)
            } else {
                this.setState({ statusMessage: response.data.message, email_address: '', phone_number: '', userDetail: false, showError: true, isShowError: false, isLoading: false });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                submitted: true,
                isLoading: false
            });
        });
    }

    getData = (queryString = "") => {
        let url = baseURL + `promocodeowners?${queryString}`;
        this.setState({
            isLoading: true,
        })
        const config = { headers: { 'Authorization': TOKEN } };
        axios.all([
            axios.get(url, config)
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data.data,
                mdata: branchResponse.data.total,
                mreferral_totals: branchResponse.data.referral_income,
                isLoading: false,
            },
                function () {
                    console.log()
                    var data = [];
                    if (this.state.admins.length > 0) {


                        for (let i = 0; i < this.state.admins.length; i++) {

                            let t_amount = { t_amount: this.formatCurrency(this.state.admins[i].referral_income.toString()) }

                            let t_customers = { t_customers: this.state.admins[i].customers.toString() }

                            let t_referred_by;

                            if (this.state.admins[i].referred_by == null) {

                                t_referred_by = { t_referred_by: "-" }
                            } else {
                                t_referred_by = { t_referred_by: this.state.admins[i].referred_by.toString() }
                            }

                            data.push(Object.assign(t_referred_by, t_customers, t_amount, this.state.admins[i]));
                            this.setState({
                                data: data
                            })
                        }
                    } else {
                        this.setState({
                            data: data,
                            isLoading: false,
                        })
                    }
                }
            );
        }))
    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }
        }).join('&');
        this.getData(queryString)
    }

    render() {
        return (
            <div >
                < >
                    < Card >
                        <CardBody >
                            <Table>

                                <h4>Active PromoCodes</h4><br />

                                <h4>Total referral income: <b>{this.formatCurrency(this.state.mreferral_totals)}</b></h4><br />

                                <div className="panel-body" >

                                    <div className="row">
                                        <div className="col-md-6">
                                        </div>

                                    </div>
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.mdata}
                                        onChange={this.tableChangeHandler} />

                                </div>
                            </Table>
                        </CardBody>

                    </Card>

                </>
            </div>

        )
    }
}